// extracted by mini-css-extract-plugin
export default {"input-header":"Textarea_input-header__tYoEr","input-error-label":"Textarea_input-error-label__avdzS","invalid-input":"Textarea_invalid-input__wY7t3"};